import ErrorBoundary from './error-boundary-container'
export { RouterErrorBoundary, RootRouterErrorBoundary } from './router-error-boundary-container'

export default ErrorBoundary
